<template>
  <q-dialog v-model="modal.show"
            @keydown.escape="close()"
            persistent
            transition-show="scale"
            transition-hide="scale">
    <q-card style="max-width: 600px; width: 100%; padding: 15px;">
      <h5>Add new depreciation override</h5>
      <div class="row">
        <div class="col col-xs-12 col-sm-6">
          <q-select label="Company"
                    v-model="selectedCompany"
                    :options="companies"
                    @input="locationsList"
                    :disable="isLoading"
                    clearable></q-select>
        </div>
        <div class="col col-xs-12 col-sm-6">
          <q-select label="Location"
                    v-model="selectedLocation"
                    :options="locations"
                    clearable
                    :error="errors.location_id !== null"
                    :error-message="errors.location_id"
                    :disable="!selectedCompany || isLoading"></q-select>
        </div>
        <div class="col col-xs-12 col-sm-6">
          <q-select label="Make"
                    v-model="selectedMake"
                    :options="makes"
                    @input="modelsList"
                    :disable="isLoading"
                    clearable></q-select>
        </div>
        <div class="col col-xs-12 col-sm-6">
          <q-select label="Model"
                    v-model="selectedModel"
                    :options="models"
                    clearable
                    :error="errors.vehicle_model_id !== null"
                    :error-message="errors.vehicle_model_id"
                    :disable="!selectedMake || isLoading"></q-select>
        </div>
        <div class="col col-xs-12 col-sm-6">
          <q-input label="Value"
                   v-model="value"
                   @keydown.enter.prevent="save"
                   :error="errors.value !== null"
                   :error-message="errors.value"
                   type="number"></q-input>
        </div>
      </div>
      <div class="flex justify-between" style="margin-top: 15px;">
        <q-btn label="Cancel"
               color="red"
               :disable="isLoading"
               @click="close()"></q-btn>
        <q-btn label="Save"
                color="green"
                :loading="isLoading"
                :disable="isLoading"
                @click="save()"></q-btn>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
export default {
  props: {
    updateTable: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: false,
      companies: [],
      selectedCompany: null,
      locations: [],
      selectedLocation: null,
      makes: [],
      selectedMake: null,
      models: [],
      selectedModel: null,
      value: null,
      errors: {
        location_id: null,
        vehicle_model_id: null,
        value: null
      }
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.state.depreciationOverrides.setCreateModal
      },
      set(value) {
        this.$store.commit('depreciationOverrides/SET_CREATE_MODAL', value)
      }
    }
  },
  mounted() {
    this.companiesList()
    this.makesList()
  },
  methods: {
    async companiesList() {
      try {
        const {data} = await axios.get('/companies')
        this.companies = data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async locationsList() {
      if (!this.selectedCompany) {
        this.locations = []
        this.selectedLocation = null
        return
      }
      try {
        let params = {}
        if (this.selectedCompany) {
          params.company = this.selectedCompany.value
        }
        this.filterLoading = true
        const {data} = await axios.get('/locations', {
          params
        })
        this.locations = data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async makesList() {
      try {
        const {data} = await axios.get('/vehicle-brands')
        this.makes = data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async modelsList() {
      if (!this.selectedMake) {
        this.models = []
        this.selectedModel = null
        return
      }

      try {
        this.filterLoading = true
        const {data} = await axios.get('/vehicle-models/' + this.selectedMake.value)
        this.models = data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    reset() {
      this.errors = {
        location_id: null,
        vehicle_model_id: null,
        value: null
      }
      this.loading = false
      this.selectedCompany = null
      this.selectedLocation = null
      this.selectedMake = null
      this.selectedModel = null
      this.value = null
    },
    close() {
      this.reset()
      this.$store.commit('depreciationOverrides/SET_CREATE_MODAL', {
        show: false
      })
    },
    async save() {
      try {
        this.isLoading = true
        await axios.put('/depreciation-overrides', {
          location_id: this.selectedLocation?.value,
          vehicle_model_id: this.selectedModel?.value,
          value: this.value
        })
        this.reset()
        this.updateTable()
      } catch (err) {
        if (err.response.status === 422) {
          this.$q.notify({
            message: err.response.data.message,
            color: 'red',
            timeout: 250,
            position: 'top-right',
            progress: true
          })
          const errors = err.response.data.errors
          Object.keys(errors).map(key => {
            this.errors[key] = errors[key][0]
          })
        } else {
          this.$q.notify({
            message: 'Something went wrong',
            color: 'red',
            timeout: 250,
            position: 'top-right',
            progress: true
          })
        }
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style scoped>
h5 {
  margin: 5px;
  font-size: 18px;
}
.col {
  padding: 0 5px;
}
.file-input label {
  display: flex;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.24);
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: #bdbdbd;
  font-weight: bold;
  transition: transform 0.2s ease-out;
  cursor: pointer;
}
input:hover + label {
  cursor: pointer;
  background: rgb(189, 189, 189, 0.2);
}
</style>
